import { usePermissions } from '../../../hooks/usePermissions';
import {
  FUEL_SURCHARGE_OVERRIDE_PERMISSION,
  HIRED_EQUIPMENT_FINANCIALS_PERMISSION,
} from '../utils/fieldVisibility';

/** Shared HE-F17 / HE-F18 check. Markup, Value, and fuel surcharge require the permission. */
export function useHiredEquipmentFieldVisibility(): {
  showFinancials: boolean;
  canOverrideFuel: boolean;
  loading: boolean;
} {
  const { hasPermission, loading } = usePermissions();
  return {
    showFinancials: hasPermission(HIRED_EQUIPMENT_FINANCIALS_PERMISSION),
    canOverrideFuel: hasPermission(FUEL_SURCHARGE_OVERRIDE_PERMISSION),
    loading,
  };
}
